import { useState } from "react";
import GetAllBiomarkersByPatientId from "../../data_layer/repositories/Biomarkers/GetAllBiomarkersByPatient";
import { is } from "date-fns/locale";

export const useGetBiomarkersListByPatientId = (patient_id, isWholeList = false) => {


    const [isLoading, setIsLoading] = useState(false);
    const [biomarkers, setBiomarkers] = useState([]);

    const getBiomarkersData = async () => {
        setIsLoading(true);
        const response = await GetAllBiomarkersByPatientId(patient_id, isWholeList);

        setBiomarkers(response);
        setIsLoading(false);
    }

    const getBiomarkers = () => {
        getBiomarkersData();
    }

    return {
        isLoading,
        biomarkers,
        getBiomarkers
    }
}
